import { deleteReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { Channel, channelFromJson, ChannelPaginationFilterRequest } from '@/models/channel.model';
import { Message, messageFromJson, MessagePaginationFilterRequest } from '@/models/message.model';

// Reads plus soft-delete of messages and channels — no create, update, archive, or role-scoping.
// Channel management stays with the club Owner and Captain (spec C-4).

export const getPagedChannels = async (input: ChannelPaginationFilterRequest): Promise<PagedResponseModel<Channel>> => {
  return await getReq(createUrl("a/Channel/PagedData"),
    { params: input }
  ).then((res: any) => ({
      ...res.data,
      result: res.data.result.map((itm: any) => channelFromJson(itm))
    }));
};

export const getChannel = async (id: number): Promise<BaseResponseModel<Channel>> => {
  return await getReq(createUrl(`a/Channel/GetById/${id}`),
  ).then((res: any) => ({
      ...res.data,
      result: channelFromJson(res.data.result)
    }));
};

export const getPagedChannelMessages = async (channelId: number, input: MessagePaginationFilterRequest): Promise<PagedResponseModel<Message>> => {
  return await getReq(createUrl(`a/Channel/${channelId}/Messages`),
    { params: input }
  ).then((res: any) => ({
      ...res.data,
      result: res.data.result.map((itm: any) => messageFromJson(itm))
    }));
};

export const deleteChannelMessage = async (messageId: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/Channel/Message/${messageId}`),
  ).then((res: any) => res.data);
};

export const deleteChannel = async (channelId: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/Channel/${channelId}`),
  ).then((res: any) => res.data);
};
